export const EVENTS = {
    'cta-tmplus--header': 1,
    'cta-tmplus--home--slider': 2,
    'cta-tmplus--lp-essay': 3,
    'cta-tmplus--lp-essay-banner': 4,
    'cta-tmplus--essay-header': 5,
    'cta-tmplus--essay-header-tooltip': 6,
    'cta-tmplus--essay-correction--unlock-errors': 7,
    'cta-tmplus--essay-correction--unlock-competence': 8,
    'cta-tmplus--ad-remove': 9,
    'cta-tmplus--ad-sidebar': 10,
    'cta-tmplus--exercise': 11,
    'cta-tmplus--user-area--essays': 12,
    'cta-tmplus--user-area--account': 13,
    'pix-generated': 14,
    'pix-expired': 15,
    'payed': 16,
    'renewal': 17,
    'cta-tmplus--menu-dropdown': 18,
    'cta-tmplus--essay-themes-banner': 19,
    'payment-data-fill': 20,
    'cta-tmplus--pricing-plan': 21,
    'cta-tmplus--user-area--subscription-expired': 22,
    'cta-tmplus--footer': 23,
    'cta-tmplus--checkout-page--header-close': 24,
    'cta-tmplus--checkout-page--ignore-link': 25,
    'cta-tmplus--essay-limit-modal': 26,
    'cta-tmplus--top-header--back-to-school': 27,
    'cta-tmplus--home-slider--back-to-school': 28,
    'cta-tmplus--gabarito': 29,
    'lp-assistant-subscribe': 30,
    'cta-tmplus-assistant-history': 31,
    'cta-tmplus-assistant-solution': 32,
    'cta-tmplus-assistant-usage-limit': 33,
    'cta-tmplus-assistant-popup-limit': 34,    
    'cta-tmplus-assistant-home-banner': 35,
    'cta-see-answer-gabarito-ad': 36,
    'cta-remove-ads-gabarito-ad': 37,
    'cta-assistant-gabarito-ad': 38,
    'cta-exercises-gabarito-ad': 39,
    'cta-assistant-widget-resolver': 40,
    'cta-assistant-widget-novaquestao': 41,
    'cta-tmplus--exercises-filter': 42,
    'cta-tmplus--pricing-testimonial': 43,
    'cta-plano-estudos-top-header': 44,
    'cta-plano-estudos-visual-banner': 45,
    'cta-plano-estudos-normal-banner': 46,
    'cta-plano-estudos-header-btn': 47,
    'cta-plano-estudos-footer-btn': 48,
    'trial-activate': 49,
    'cta-exercises-gabarito-trial': 50,
};
